import { render, staticRenderFns } from "./SidebarAppContainer.vue?vue&type=template&id=96d43182&scoped=true&"
import script from "./SidebarAppContainer.vue?vue&type=script&lang=js&"
export * from "./SidebarAppContainer.vue?vue&type=script&lang=js&"
import style0 from "./SidebarAppContainer.vue?vue&type=style&index=0&id=96d43182&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96d43182",
  null
  
)

export default component.exports